import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

export type CalendarEventColor = {
  hasColor: boolean;
  code?: string;
  category: string;
};

@Component({})
export default class CalendarDayColor extends Vue {
  @Prop({ type: Object }) item!: CalendarEventColor;

  get className() {
    const { hasColor, code } = this.item;
    return hasColor ? '' : `bg-category ${code}`;
  }
}
